// https://stackoverflow.com/questions/43010737/way-to-tell-typescript-compiler-array-prototype-filter-removes-certain-types-fro
export function isDefined<T>(argument: T | undefined): argument is T {
  return argument !== undefined
}

export function isNonNull<T>(value: T): value is NonNullable<T> {
  return value !== null;
}

export function isNotNullOrUndefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function isNotEmptyString(value: string | null | undefined): value is string {
  return value !== null && value !== undefined && value !== '';
}

export function isNotEmptyArray<T>(value: T[] | null | undefined): value is T[] {
  return value !== null && value !== undefined && value.length > 0;
}